import type { EventKey } from 'cadenza/utils/event-util';
import { on, unByKey } from 'cadenza/utils/event-util';
import type { ConditionElement } from 'cadenza/conditions/condition-element';
import { CONDITION_CHANGE } from 'cadenza/conditions/event-types';

const COMPONENT_NAME = 'd-condition-wrapper';

export class ConditionWrapper extends HTMLElement {

  readonly #initiallyFocused;
  // ! – initialized in `connectedCallback`
  #eventKeys!: EventKey[];
  // ! – initialized in `connectedCallback`
  #condition!: ConditionElement;
  // ! – initialized in `connectedCallback`
  #resetBtn!: HTMLButtonElement;

  constructor (focused: boolean) {
    super();
    this.#initiallyFocused = focused;
  }

  connectedCallback () {
    this.classList.add(COMPONENT_NAME, 'condition-wrapper');
    setTimeout(() => { // Light DOM is ready
      this.#condition = this.querySelector('.condition')!;
      this.#resetBtn = this.querySelector('.d-condition--clear')!;
      this.updateResetBtnVisibility();
      if (this.#initiallyFocused) {
        this.#condition.focus();
      }
      this.#eventKeys = [
        on(this.#resetBtn, 'click', () => this._onResetCondition()),
        on(this, CONDITION_CHANGE, () => this._onConditionChange())
      ];
    });
  }

  disconnectedCallback () {
    unByKey(this.#eventKeys);
  }

  _onResetCondition () {
    this.#condition.focus();
    this.resetCondition();
  }

  _onConditionChange () {
    this.updateResetBtnVisibility();
  }

  resetCondition (triggerConditionChange = true) {
    if (this.#condition) { // if condition already rendered
      this.#condition.reset(triggerConditionChange);
      this.#resetBtn.hidden = true;
    }
  }

  updateResetBtnVisibility () {
    this.#resetBtn.hidden = !this.#condition.changed;
  }

}

customElements.define(COMPONENT_NAME, ConditionWrapper);
